/* ════ KEYBOARD ════════════════════════════════════════════ */
import { state } from './state.js';
import { $ } from './dom.js';
import { addD } from './utils/date.js';
import { buildGantt } from './gantt/index.js';
import { openNew, closeModal } from './modals/task.js';
import { openIdeaModal, closeIdeaModal } from './modals/idea.js';
import { closeResModal } from './modals/resource.js';
import { popUndo } from './gantt/undo.js';
import { dbUpdate } from './supabase/data.js';
import { showToast } from './utils/toast.js';

export function initKeyboard() {
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeModal(); closeIdeaModal(); closeResModal(); $('mini-cal').classList.remove('open'); }
    // Undo the last planner move/resize.
    if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'Z')) {
      e.preventDefault(); const u = popUndo();
      if (u) { dbUpdate(u.id, u.before); showToast('Undone'); } else showToast('Nothing to undo');
      return;
    }
    if (!['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName) && $('app').classList.contains('on')) {
      if (e.key === 'n' || e.key === 'N') { if (state.currentView === 'ideas') openIdeaModal(); else openNew('', '', ''); }
      if (e.altKey && e.key === 'ArrowLeft') { state.viewStart = addD(state.viewStart, -state.viewDays); buildGantt(); }
      if (e.altKey && e.key === 'ArrowRight') { state.viewStart = addD(state.viewStart, state.viewDays); buildGantt(); }
      // Plain ← / → scroll the planner by a week (full span on month+ views).
      if (!e.altKey && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && state.currentView === 'gantt') {
        e.preventDefault();
        const step = state.viewDays <= 42 ? 7 : state.viewDays;
        state.viewStart = addD(state.viewStart, e.key === 'ArrowLeft' ? -step : step); buildGantt();
      }
      if (e.key === 't' || e.key === 'T') $('btn-today')?.click();
    }
  });
}
